import { RouterProvider } from 'react-router';
import { router } from '@/app/runtime';

/**
 * 라우터를 React 트리에 연결하는 진입 컴포넌트.
 * 라우터 인스턴스·가드·라우트 정의의 합성은 `composition.ts` 가 담당.
 */
export function AppRouter() {
  return <RouterProvider router={router} />;
}
